import { Box, Button, Stack, styled, Typography } from '@mui/material';
import ReturnLink from './ReturnLink';

const PREFIX = 'PageHeader';

const classes = {
  container: `${PREFIX}-container`,
  row: `${PREFIX}-row`,
  editButton: `${PREFIX}-edit-button`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 0,
  },

  [`&.${classes.editButton}`]: {
    minWidth: 144,
  },
}));

interface PageHeaderProps {
  title: string;
  returnLink?: string;
  returnLinkText?: string;
  primaryActionText?: string;
  primaryActionDisabled?: boolean;
  primaryActionClassName?: string;
  onPrimaryAction?: () => void;
}

const PageHeader = ({
  title,
  returnLink,
  returnLinkText,
  primaryActionText,
  primaryActionDisabled = false,
  primaryActionClassName = '',
  onPrimaryAction = undefined,
}: PageHeaderProps) => {
  return (
    <StyledBox className={classes.container}>
      <Stack direction="column">
        {returnLink && returnLinkText && (
          <ReturnLink returnLink={returnLink} returnLinkText={returnLinkText} />
        )}

        <Typography variant="h2">{title}</Typography>
      </Stack>
      {primaryActionText && onPrimaryAction && (
        <Button
          className={`${classes.editButton} ${primaryActionClassName}`}
          variant="contained"
          disabled={primaryActionDisabled}
          onClick={onPrimaryAction}>
          {primaryActionText}
        </Button>
      )}
    </StyledBox>
  );
};

export default PageHeader;
